module.exports = __webpack_public_path__ + "static/media/warning.faea2195.svg";